export default "__VITE_ASSET__B0gSBR9r__"